// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(min-width: 1024px)";
var _4 = "baggageBanner-Yq72K";
var _5 = "text-NgfmA";
var _6 = "disclaimer-oUPNP";
var _7 = "disclaimer__icon-1Hrhy";
var _8 = "image-1QRxB";
export { _1 as "__esModule", _2 as "mobile", _3 as "desktop_only", _4 as "baggageBanner", _5 as "text", _6 as "disclaimer", _7 as "disclaimer__icon", _8 as "image" }
export default { "__esModule": _1, "mobile": _2, "desktop_only": _3, "baggageBanner": _4, "text": _5, "disclaimer": _6, "disclaimer__icon": _7, "image": _8 }
